import { normalizeVidhyantraDomain } from '@/utils/cookie-domain.util'

/** Deployed non-production apex (QubiNest-style: staging under prod TLD). */
export const STAGING_BASE_DOMAIN = 'staging.vidhyantra.com'

export const STAGING_INFRA_LABELS = [
  'www',
  'api',
  'dev-api',
  'cloud',
  'platform',
  'app',
  'docs',
  'staging',
] as const

export function normalizeHostname(hostname: string): string {
  return normalizeVidhyantraDomain(hostname.split(':')[0] ?? hostname).toLowerCase()
}

export function isStagingDeployHostname(hostname: string): boolean {
  const host = normalizeHostname(hostname)
  return host === STAGING_BASE_DOMAIN || host.endsWith(`.${STAGING_BASE_DOMAIN}`)
}

export function isStagingApexHostname(hostname: string): boolean {
  const host = normalizeHostname(hostname)
  return host === STAGING_BASE_DOMAIN || host === `www.${STAGING_BASE_DOMAIN}`
}

/** e.g. acme.staging.vidhyantra.com → acme */
export function extractOrgSlugFromStagingHostname(hostname: string): string | null {
  const host = normalizeHostname(hostname)
  if (!host.endsWith(`.${STAGING_BASE_DOMAIN}`)) return null

  const label = host.slice(0, -(STAGING_BASE_DOMAIN.length + 1))
  if (!label || label.includes('.')) return null
  if ((STAGING_INFRA_LABELS as readonly string[]).includes(label)) return null

  return label
}
